var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey"},[_c('div',{staticClass:"row"},[_c('member-list',{staticClass:"pt-3",attrs:{"facets":_vm.supportFacets,"query":_vm.supportQuery,"fields":_vm.supportFields,"title":this.$t('labels.supporters')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }